module.exports = __webpack_public_path__ + "static/media/galerija_2021 (17).e63ce134.jpg";